<script lang="ts">
  import { getContext } from "svelte";
import { ethereum } from "../store/ethereum";
  import ContractModal from "./modals/ContractModal.svelte";
import ReferralModal from "./modals/ReferralModal.svelte";

  const { open } = getContext("simple-modal");
  const showReferrals = () => {open(ReferralModal, {address: $ethereum.address})}
  const showContracts = () => [open(ContractModal, {})];
  const openHelp = () => {
    const w = (window as any)
    w.LiveChatWidget.call("maximize");
  }
</script>

<footer>
  <div class="footer_outer">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="footer_links">
            <ul>
              <li><a href="https://coinmarketcap.com/currencies/dogs-of-elon/" target="_blank" rel="noreferrer">CoinMarketCap</a></li>
              <li><a href="https://etherscan.io/token/0xf8e9f10c22840b613cda05a0c5fdb59a4d6cd7ef" target="_blank" rel="noreferrer">Etherscan</a></li>
              <li><a href="https://www.coingecko.com/en/coins/dogsofelon" target="_blank" rel="noreferrer">CoinGecko</a></li>
              <li><a href="https://www.dextools.io/app/ether/pair-explorer/0xa626eb9cc7dec00703586414d0811e1ba2021443" target="_blank" rel="noreferrer">DexTools</a></li>
              <li><a href="/privacypolicy" rel="noreferrer">Privacy Policy</a></li>                
            </ul>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <p class="footer_p">
            Cryptoasset Disclaimer: Trading/Minting crypto-assets carries a high level of risk, and may not be suitable for all investors. The possibility exists that you could sustain a loss of some or all of your initial investment and therefore you should not invest money that you cannot afford to lose.
          </p>
        </div>
      </div>
    </div>
  </div>
</footer>


<style>
  .footer_outer{
  background-color: #1E2031;
  padding: 40px 0;
}

.footer_links ul{
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.footer_links li
{
  display: inline-block;
  margin-right: 60px;
}
.footer_links ul li:last-child{
  margin-right: 0;
} 
.footer_links a{
  font-size: 18px;
  color: #fff;
  text-decoration: none;
}
.footer_p{
  color: #A1A1A1;
  font-weight: 200;
  font-style: italic;
  margin-bottom: 0;
}
@media (max-width:1200px){
  .footer_links li{
    margin-right: 40px;
  }
}
@media (max-width:992px){
  .footer_links ul{
    text-align: center;
    margin-bottom: 30px;
  }
}
@media (max-width:580px){
  .footer_links li{
    display: block;
    margin-right: 0;
    margin-bottom: 15px;
  }
}

</style>
